import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null,
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    SET_USER(state, user) {
      state.currentUser = user
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    }
  },
  actions: {
    login({ commit }, userInfo) {
      // 这里可以添加登录逻辑
      commit('SET_USER', userInfo)
    },
    logout({ commit }) {
      commit('SET_USER', null)
      commit('SET_TOKEN', '')
      localStorage.removeItem('token')
    }
  },
  modules: {}
})
